import React, { MouseEvent, ReactNode } from 'react';
import Modal from 'react-modal';

interface VideoModalProps {
  isVisible: boolean;
  children: ReactNode;
  onClose: () => void; // Change the type to a function that takes no arguments
}

const VideoModal: React.FC<VideoModalProps> = ({ isVisible, children,onClose }) => {
  return(
        <Modal      
      isOpen={isVisible}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
          backgroundColor:'black',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: 0,
          border: 'none',
          width: '80%', // Adjust the width as needed
          height: '80%', // Adjust the height as needed
        },
      }}
    >
{children}

</Modal>
    )
}

export default VideoModal